/* ============
 * axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import Vue from 'vue'
import axios from 'axios'

// config axios
axios.defaults.headers.common.Accept = 'application/json'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.baseURL = 'https://apiservizicartografici.tecnograph-group.com'
// axios.defaults.withCredentials = true

// Bind Axios to Vue.
Vue.axios = axios
Object.defineProperty(Vue.prototype, 'axios', {
    get() {
        return axios
    }
})
